module.exports = __webpack_public_path__ + "static/media/footer-logo.4239886d.png";